import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import {
  sendDocumentSubdomain,
  updateStatusSubdomain,
} from "features/common/layouts/cartSlice";
import { useDispatch } from "react-redux";
import customInput from "../../assets/scss/ModalSubDomain.module.scss";
import { useSelector } from "react-redux";
import { notifyWarning, notifyError, notifySuccess } from "components/ToastMessage";

const ModalSubDomain = (props) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  const { documentSuratSubdomain } = useSelector((state) => state.cart);
  const [disabledButton, setDisabledButton] = useState(false);

  const handleFileChange = (event) => {
    const imageFile = event.target.files[0];
    setFile(imageFile);
  };

  const handlerSendDocument = (e) => {
    e.preventDefault();
    if (!file) {
      notifyWarning("File Surat Kuasa Anda Belum Terisi!");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      notifyError(
        "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
      );
      return;
    }

    if (
      file.type !== "image/jpg" &&
      file.type !== "image/png" &&
      file.type !== "image/jpeg" &&
      file.domain_upload.type !== "application/pdf"
    ) {
      notifyError(
        "Maaf, hanya file dengan ekstensi PDF, PNG, JPG, dan JPEG yang diperbolehkan."
      );
      return;
    }

    setDisabledButton(true);
    setLoading(true);
    dispatch(sendDocumentSubdomain(file));
    setFile("");
  };

  useEffect(() => {
    if (documentSuratSubdomain.status === "fulfilled") {
      setLoading(false);
      setDisabledButton(false); 
      notifySuccess(
        `Kelengkapan Domain Bersyarat ${props.domain} Berhasil di Upload!`
      );
      dispatch(updateStatusSubdomain("idle"));
      props.onHide();
    } else if (documentSuratSubdomain.status === "error") {
      setLoading(false);
      setDisabledButton(false);
      notifyError(`${documentSuratSubdomain.error}`);
      dispatch(updateStatusSubdomain("idle"));
    } else if (documentSuratSubdomain.status === "idle") {
      setLoading(false);
      setDisabledButton(false);
    }
  }, [
    dispatch,
    documentSuratSubdomain.status,
    documentSuratSubdomain.message,
    documentSuratSubdomain.error,
    props,
  ]);

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold fs-4">Domain Bersyarat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="mb-3 mt-3 fw-bold text-qw-primary fs-5">
            Domain: {props.domain}
          </h3>
          <div className="form">
            <div className="mb-3">
              <Form.Group controlId="surat-kuasa-subdomain" className="mb-3">
                <Form.Label>Surat Kuasa Pimpinan Kampus/Instansi*</Form.Label>
                <div className="d-flex">
                  <Form.Control
                    className={`${customInput["custom-file"]}`}
                    type="file"
                    name="surat-kuasa-subdomain"
                    onChange={handleFileChange}
                  />
                  <Form.Label className={`${customInput["custom-button"]}`}>
                    Pilih Gambar
                  </Form.Label>
                </div>
                <p className="text-secondary mt-2" style={{ fontSize: "12px" }}>
                  <i>
                    *File: Maks. 2MB, tipe yang diperbolehkan: PNG, JPG, JPEG,
                    PDF.
                  </i>
                </p>
              </Form.Group>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12">
              <button
                className="btn btn-modal-login w-100"
                disabled={disabledButton}
                onClick={handlerSendDocument}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Simpan"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalSubDomain;
